import { routes } from '@routes';
import { ConnectIntegrationContent } from '@organisms/ConnectIntegration/ConnectIntegrationContent';
import { Page } from '@components';

export function ConnectIntegrationPage() {
  return (
    <Page
      contentCentered
      contentPadded
      breadcrumbs={[
        {
          label: routes.Catalog.label,
          href: routes.Catalog.path,
        },
      ]}
      title={routes.ConnectIntegration.label}
      containerWidth="md"
    >
      <ConnectIntegrationContent
        paths={{
          catalogPath: routes.Catalog.path,
          editPath: routes.EditIntegration.path,
        }}
      />
    </Page>
  );
}
